import React, {useEffect} from 'react';
import Card from './Card';

function SearchList({ filteredPersons, handleCardClick, maxCards,
  CardComponent = Card }) {

  useEffect(() => {
    console.log("Received filteredPersons:", filteredPersons);
  }, [filteredPersons]);

  return (
    <div>
      {filteredPersons.length > maxCards && (
        <p>Showing only {maxCards} out of {filteredPersons.length} results</p>
      )}
      {filteredPersons.slice(0, maxCards).map((person) => (
        <CardComponent person={person} key={person.id} onClick={() => handleCardClick(person)} />
      ))}
    </div>
  );
}

export default SearchList;
